import axios from 'axios';
import ApiClient from './ApiClient';

export const getItem = async (mail: string, siteType: string): Promise<any> => {
  // TODO 仮リクエスト
  const params = {
    mail,
    siteType,
  };

  const response = await ApiClient.get('/v2/loginuser', params);
  return response.data;
};

export const getInfomationOrgLocalStorage = async (
  companyCode : string,
  specifyCode: string,
): Promise<Array<any>> => {
  const params = {
    specifyCode,
  };
  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/whereami/${companyCode}`, {
    params,
    data: {},
  });
  return response.data;
};

export const isValidToken = async (): Promise<Array<any>> => {
  const params = {};
  const response = await ApiClient.get('/v1/tokenExpiration', params);
  return response.data;
};

export const getUserLoginStatus = async (): Promise<any> => {
  
  const params = {
  };

  const response = await ApiClient.get('/v1/loginStatus', params);
  return response.data;
};

export const logout = async (): Promise<any> => {
  
  const params = {
  };

  const response = await ApiClient.get('/v2/logout', params);
  return response.data;
};

export default getItem;

export const saveLoginHistory = async (mail: String, loginResult: boolean, failPassword: String, failReason: String)
 : Promise<any> => {
  const prams = {
    mail,
    loginResult,
    failPassword,
    failReason,
  };
  const reponse = await ApiClient.postLoginHistory('/v1/login/history', {}, prams);
  return reponse.data;
};

export const saveAccessHistory = async (companyCode: String, staffCode: String, accessUrl: String)
 : Promise<any> => {
  if (companyCode === '' || staffCode === '') {
    return null;
  }
  const prams = {
    companyCode,
    staffCode,
    accessUrl,
  };
  const reponse = await ApiClient.post('/v1/access/history', {}, prams);
  return reponse.data;
};
